import * as API from '@/services/API';

export default {
    getRegions () {
        return API.apiClient.get('/regions');
    }
};
